<template>
  <v-card flat class="publisher">

    <template>
      <v-card flat class="pa-5">
        <div class="pa-3">
          {{ $t('apc.description') }}
        </div>
        <div class="pa-3">
          {{ $t('apc.dataSource') }}
        </div>
        <div class="pa-3">
          <i18n path="apc.readDocs" tag="span">
            <template #link>
              <a :href="$docsUrl('how-to-guides/apc-report')" target="_blank">{{ $t('apc.docsLinkText') }}</a>
            </template>
          </i18n>
        </div>
      </v-card>
    </template>

    <template>
      <v-card flat class="pa-5">
        <div class="d-flex px-3">
          <v-btn color="primary" @click="" :href="csvUrl">
            <v-icon left>mdi-download</v-icon>
            {{ $t('common.download') }}
          </v-btn>
        </div>
      </v-card>
    </template>

  </v-card>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import {urlBase} from "../../api";

export default {
  name: "InstitutionApcTab",
  components: {},
  data() {
    return {
      search: "",
    }
  },
  computed: {
    ...mapGetters([
      "institutionName",
      "institutionId",
      "institutionIsJisc",
      "institutionIsConsortium",
    ]),
    csvUrl() {
      // urlBase ends with a slash
      let url = `${urlBase}institution/${this.institutionId}/apc/export.csv`;
      url += "?timestamp=" + `${new Date().getTime()}`
      url += "&jwt=" + localStorage.getItem("token")
      return url
    },
  },
  methods: {},

  created() {
  },
  async mounted() {


  },
}
</script>

<style lang="scss">
.v-toolbar__extension {
  border-top: none !important;
}

</style>
